module.exports = __webpack_public_path__ + "static/media/imgPrice.5842cd35.svg";